import { Controller } from "@hotwired/stimulus";

// Génération en masse des documents intervenant.
//
// Une ligne par intervenant, avec la liste des types de documents qu'il a
// déjà (`data-existing`). Quand le type change, on marque et on décoche ceux
// qui l'ont déjà : le serveur les ignorerait de toute façon, autant que ce
// soit visible avant de cliquer plutôt que découvert dans le message de
// retour.
export default class extends Controller {
  static targets = ["typeSelect", "row", "box", "already", "count"];

  connect() {
    this.typeChanged();
  }

  typeChanged() {
    const typeId = this.hasTypeSelectTarget ? this.typeSelectTarget.value : null;

    this.rowTargets.forEach((row) => {
      const existants = (row.dataset.existing || "")
        .split(",")
        .filter((v) => v.length > 0);
      const deja = typeId !== null && existants.includes(String(typeId));
      const box = row.querySelector("input[type=checkbox]");
      const mention = row.querySelector("[data-bulk-doc-generation-target=already]");

      row.classList.toggle("esm_wizard__participant-row--prefilled", deja);
      if (mention) mention.hidden = !deja;
      if (box) {
        box.checked = !deja;
        box.disabled = deja;
      }
    });

    this.refreshCount();
  }

  selectAll() {
    this.boxTargets.forEach((b) => {
      if (!b.disabled) b.checked = true;
    });
    this.refreshCount();
  }

  selectNone() {
    this.boxTargets.forEach((b) => {
      b.checked = false;
    });
    this.refreshCount();
  }

  refreshCount() {
    if (!this.hasCountTarget) return;

    const total = this.boxTargets.filter((b) => b.checked).length;
    this.countTarget.textContent = total === 0 ? "" : ` · ${total} sélectionné${total > 1 ? "s" : ""}`;
  }
}
